import axios from "axios";

const DEFAULT_STRIPE_API_BASE_URL = process.env.REACT_APP_API_URL;

export function getStripeApiBaseUrl() {
  return (
    process.env.REACT_APP_STRIPE_API_BASE_URL ||
    process.env.REACT_APP_PAYMENT_API_BASE_URL ||
    DEFAULT_STRIPE_API_BASE_URL
  ).replace(/\/+$/, "");
}

export async function createStripePaymentIntent(
  parcelId,
  { currency = "gbp" } = {},
) {
  const baseUrl = getStripeApiBaseUrl();
  const url = `${baseUrl}/Payment/create-payment-intent`;

  const normalizedCurrency =
    typeof currency === "string" && currency.trim()
      ? currency.trim().toLowerCase()
      : "gbp";
  const id =
    typeof parcelId === "string" ? parseInt(parcelId, 10) : Number(parcelId);

  const res = await axios.post(
    url,
    { parcelId: id, currency: normalizedCurrency },
    {
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
      },
    },
  );

  return res.data;
}

export function persistStripePaymentRecordIdFromIntentResponse(data) {
  if (!data || typeof data !== "object") return;
  const recordId =
    data.paymentId ??
    data.PaymentId ??
    data.id ??
    data.paymentRecordId ??
    data.Payment?.id;
  if (recordId == null || recordId === "") return;
  sessionStorage.removeItem("stripePaymentUpdateSent");
  sessionStorage.setItem("stripePaymentRecordId", String(recordId));
}

export function buildUpdateBodyFromPaymentIntent(
  paymentIntent,
  queryFallback = {},
) {
  const fallbackPiId = queryFallback.paymentIntentId || "";
  const paymentStatusId =
    queryFallback.paymentStatusId !== undefined &&
    queryFallback.paymentStatusId !== null
      ? Number(queryFallback.paymentStatusId)
      : undefined;
  if (!paymentIntent) {
    return {
      stripePaymentIntentId: fallbackPiId,
      stripeChargeId: "",
      cardLast4: "",
      cardBrand: "",
      stripePaymentMethod: "",
      ...(Number.isFinite(paymentStatusId)
        ? { PaymentStatusId: paymentStatusId }
        : {}),
    };
  }

  const lc = paymentIntent.latest_charge;
  const chargeId =
    typeof lc === "string"
      ? lc
      : lc && typeof lc === "object" && "id" in lc
        ? lc.id
        : (paymentIntent.charges?.data?.[0]?.id ?? "");

  const pm = paymentIntent.payment_method;
  const pmId = typeof pm === "string" ? pm : (pm?.id ?? "");
  const card = typeof pm === "object" && pm?.card ? pm.card : null;

  return {
    stripePaymentIntentId: paymentIntent.id ?? fallbackPiId,
    stripeChargeId: chargeId ?? "",
    cardLast4: card?.last4 ?? "",
    cardBrand: card?.brand ?? "",
    stripePaymentMethod: pmId,
    ...(Number.isFinite(paymentStatusId)
      ? { PaymentStatusId: paymentStatusId }
      : {}),
  };
}

export async function putUpdatePaymentForStripe(paymentRecordId, body) {
  const baseUrl = getStripeApiBaseUrl();
  const url = `${baseUrl}/Payment/UpdatePaymentForStripePayment/${paymentRecordId}`;
  await axios.put(url, body, {
    headers: {
      accept: "*/*",
      "Content-Type": "application/json",
    },
  });
}

export async function syncStripePaymentToBackend(paymentIntent, queryFallback) {
  console.log("Syncing Stripe payment to backend...", {
    paymentIntent,
    queryFallback,
  });
  const recordId =
    sessionStorage.getItem("stripePaymentRecordId") ||
    sessionStorage.getItem("stripePaymentId") ||
    (() => {
      try {
        const raw = localStorage.getItem("paymentSlipData");
        if (!raw) return "";
        const slip = JSON.parse(raw);
        const v = slip?.parcelId;
        const n = typeof v === "string" ? parseInt(v, 10) : Number(v);
        return Number.isFinite(n) && n > 0 ? String(n) : "";
      } catch {
        console.warn(
          "Failed to parse paymentSlipData from localStorage for record id fallback.",
        );
        return "";
      }
    })();

  if (!recordId) {
    console.warn(
      "Stripe update skipped: missing payment record id. " +
        "Expected sessionStorage.stripePaymentRecordId (or paymentSlipData.parcelId fallback).",
    );
    return;
  }
  // if (sessionStorage.getItem("stripePaymentUpdateSent") === "1") {
  //   console.warn(
  //     "Stripe update skipped: update already sent for this payment record id.",
  //   );
  //   return;
  // }

  sessionStorage.setItem("stripePaymentUpdateSent", "1");
  const body = buildUpdateBodyFromPaymentIntent(paymentIntent, queryFallback);
  try {
    await putUpdatePaymentForStripe(recordId, body);
  } catch (err) {
    sessionStorage.removeItem("stripePaymentUpdateSent");
    console.error("UpdatePaymentForStripePayment failed:", err);
  }
}
